export default {
    accountOrPasswordError: "Account name or password is error",
    noAuth: "No permission at present, please contact customer service personnel!"
}